import { Calendar } from 'owa-calendar-cache';
import { action } from 'satcheljs';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';

export let setCalendarHexColor = action(
    'setCalendarHexColor',
    (calendar: Calendar, newColor: string) => ({
        calendar: calendar,
        newColor: newColor,
    })
);

export let setCalendarColorScheme = action(
    'setCalendarColorScheme',
    (calendar: Calendar, colorScheme: ColorScheme) => ({
        calendar: calendar,
        colorScheme: colorScheme,
    })
);

export default setCalendarHexColor;
